import { Component, OnInit, Input } from '@angular/core';
import { Employee } from '@akiba/models_bimbo';

@Component({
  selector: 'app-employee-general-information',
  templateUrl: './employee-general-information.component.html',
  styleUrls: ['./employee-general-information.component.scss']
})
export class EmployeeGeneralInformationComponent implements OnInit {

  @Input() disabled: boolean;
  @Input() employee: Employee;
  constructor() { }

  ngOnInit() {
  }

}
